/**
 * 聚焦 Naive UI card preset 弹框的可见根节点。
 *
 * Naive UI 的 FocusTrap 在内容尚未完成入场时可能会把焦点落到
 * `aria-hidden` 的焦点哨兵上，Chrome 会因此输出无障碍警告。
 * 这里在弹框入场结束后显式聚焦真实卡片节点，既保留弹框内焦点，
 * 也避免隐藏哨兵成为当前焦点。
 *
 * @param enteredElement 弹框入场动画结束时传出的 DOM 节点。
 */
export function focusNaiveModalCardAfterEnter(enteredElement?: unknown): void {
  if (!(enteredElement instanceof HTMLElement)) return;

  enteredElement.focus({ preventScroll: true });
}
